import React from 'react';
import { Grid } from '@mui/material';
import ShareDatasetButton from '../../../../components/ShareDatasetButton/ShareDatasetButton';
import { ACL_PERMISSIONS } from '../../../../services/config/accessControl';
import { useSelectedDataset } from '../../../../state/hooks/DatastoreHooks';
import { useOrganizationData } from '../../../../state/hooks/OrganizationHooks';
import { PermissionsGate } from '../../../../ui';
import { useActionsToolbar } from './ActionsToolbarHooks';
import {
  CreateDataStoreItemButton,
  DeleteDatastoreButton,
  DownloadLogsButton,
  DownloadValidationReportButton,
  DownloadZipArchiveButton,
  PushDataStoreButton,
  StartCheckingButton,
  ToggleNotificationsButton,
} from './components';

export const ActionsToolbar = () => {
  const dataset = useSelectedDataset() ?? {};
  const { datastorePermissionsLabels } = useActionsToolbar();
  const userPermissionsInCurrentOrganization = useOrganizationData()?.security?.currentUserPermissions ?? [];

  return (
    <Grid
      container
      sx={{ gap: 0, p: 1 }}
      wrap="wrap"
      justifyContent="flex-end"
      alignContent="flex-start"
      alignItems="center"
    >
      <PermissionsGate
        userPermissions={userPermissionsInCurrentOrganization}
        necessaryPermissions={[ACL_PERMISSIONS.ORGANIZATION.CREATE_CHILDREN]}
        noPermissionProps={{ disabled: true }}
      >
        <CreateDataStoreItemButton />
      </PermissionsGate>
      <StartCheckingButton />
      <PushDataStoreButton />
      <ToggleNotificationsButton />
      <ShareDatasetButton dataset={dataset} permissionsLabels={datastorePermissionsLabels} />
      <DownloadZipArchiveButton />
      <DownloadValidationReportButton />
      <DownloadLogsButton runnerName="validation" />
      <DeleteDatastoreButton />
    </Grid>
  );
};
